// Helpers compartilhados do módulo de Ordem de Serviço.
// Centraliza lógica que estava duplicada em ListaOS / CriarOS / DetalhesOS.
// IMPORTANTE: comportamento idêntico ao original — apenas extraído para reuso.

// Tipo de serviço que exige assinatura do cliente (regra de negócio).
export const TIPO_ENTREGA = "Entrega de Equipamentos"

// Tokens de cor do tema SCSS (src/assets/scss/_variables.scss).
// Usados para alimentar primaryColor/hoverColor do Button compartilhado.
export const THEME = {
  primary: "#3476F6",
  success: "#34c38f",
  info: "#50a5f1",
  warning: "#f1b44c",
  danger: "#f46a6a",
  neutral: "#74788d",
  light: "#f8f7ff",
}

// Mapa de status -> { color (cor do badge/tema), label (rótulo PT-BR) }.
// Idêntico ao statusMap original de DetalhesOS/ListaOS.
const STATUS_MAP = {
  ABERTO: { color: "warning", label: "Em aberto" },
  OPEN: { color: "warning", label: "Em aberto" },
  ANDAMENTO: { color: "info", label: "Em andamento" },
  IN_PROGRESS: { color: "info", label: "Em andamento" },
  CONCLUIDA: { color: "success", label: "Concluída" },
  CONCLUIDO: { color: "success", label: "Concluída" },
  CANCELADA: { color: "danger", label: "Cancelada" },
  CANCELADO: { color: "danger", label: "Cancelada" },
}

export const getStatusBadge = status => {
  return STATUS_MAP[status] || { color: "secondary", label: status }
}

// Fuso do negócio: as datas de OS representam o dia civil no Brasil.
const TIMEZONE_BR = "America/Sao_Paulo"

const formatadorDiaBR = new Intl.DateTimeFormat("pt-BR", {
  timeZone: TIMEZONE_BR,
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
})

// A API devolve a data de criação como dia civil: só "AAAA-MM-DD" ou com hora
// zerada em UTC. Passar esses valores por `new Date` os interpreta como
// meia-noite UTC e, em UTC-3, exibe o dia anterior — então extraímos direto.
const DIA_CIVIL = /^(\d{4})-(\d{2})-(\d{2})(?:[T ]00:00(?::00(?:\.\d+)?)?(?:Z|\+00:?00)?)?$/

// Data ISO/Date -> dd/mm/aaaa no fuso de São Paulo.
export const formatarData = (data, vazio = "-") => {
  if (!data) return vazio

  if (typeof data === "string") {
    const valor = data.trim()
    if (valor.includes("/")) return valor

    const diaCivil = DIA_CIVIL.exec(valor)
    if (diaCivil) {
      const [, ano, mes, dia] = diaCivil
      return `${dia}/${mes}/${ano}`
    }
  }

  const date = data instanceof Date ? data : new Date(data)
  if (Number.isNaN(date.getTime())) {
    return typeof data === "string" ? data : vazio
  }
  return formatadorDiaBR.format(date)
}

// String "AAAA-MM-DD" -> "DD/MM/AAAA". Igual ao formatarDataBR de CriarOS.
export const formatarDataBR = data => {
  if (!data) return ""
  const [ano, mes, dia] = data.split("-")
  return `${dia}/${mes}/${ano}`
}

// Estilos do react-select usados nos selects do módulo (fundo branco + hover).
// Eram 3 cópias idênticas em ListaOS / CriarOS / DetalhesOS; centralizado aqui.
export const selectMenuStyles = {
  control: base => ({
    ...base,
    backgroundColor: "#fff",
  }),
  menu: base => ({
    ...base,
    backgroundColor: "#fff",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#e0dcdc" : "#fff",
    color: "#000",
  }),
}
